import { Component, OnInit, OnDestroy } from '@angular/core';
import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { Router } from '@angular/router';
import { timer, Subscription } from 'rxjs';
import { CommonDataService } from '../../../Common/common-data.service';
import { HierarchyService } from '../../../service/hierarchy.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit, OnDestroy {
  collectionpointId: string | number | null = null;
  collectionpointName: string = '';
  dateTime!: Date;
  societyId: string | number | null = null;
  bccId: string | number | null = null;
  bccName: string = '';
  displayId: string | number | null = null;
  userAccessLevel: string = '';

  private timerSub?: Subscription;

  constructor(
    private classToggler: ClassToggleService,
    private commonData: CommonDataService,
    private hierarchyService: HierarchyService,
    private router: Router
  ) {
    super();

    try {
      this.collectionpointId = this.commonData?.collectionpoint_id ?? null;
      this.collectionpointName = this.commonData?.collectionpoint_name ?? '';
      this.societyId = this.commonData?.societyId ?? null;
    } catch (err) {
      this.collectionpointId = null;
      this.collectionpointName = '';
      this.societyId = null;
    }
  }

  ngOnInit(): void {
    this.timerSub = timer(0, 1000).subscribe(() => {
      this.dateTime = new Date();
    });

    this.userAccessLevel = localStorage.getItem('userAccessLevel') || '';
    this.loadDisplayId();
  }

  ngOnDestroy(): void {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  loadDisplayId(): void {
    try {
      // Get bccName and bccId from flattenedBCCs
      const bccs = JSON.parse(localStorage.getItem('flattenedBCCs') || '[]');
      if (bccs.length > 0) {
        this.bccName = bccs[0].bccName; // e.g. "110"
        this.bccId = bccs[0].bccId;     // e.g. 5
      }

      if (this.userAccessLevel.includes('BCC')) {
        // BCC login: bccName displayed directly in template, no displayId needed
        return;
      }

      // Collection Point login: displayId = bccName + collectionPointId e.g. "11014"
      if (this.bccName && this.collectionpointId) {
        this.displayId = `${this.bccName}${this.collectionpointId}`;
        console.log('Displaying (bccName + collectionPointId):', this.displayId);
      } else if (this.collectionpointId) {
        this.displayId = this.collectionpointId;
      } else {
        this.displayId = null;
      }

    } catch (error) {
      console.error('Error loading display ID:', error);
      this.displayId = this.collectionpointId ?? null;
    }
  }

  toggleTheme(): void {
    this.classToggler.toggle('.c-app', 'c-dark-theme');
  }

  confirmLogout(): void {
    const confirmed = confirm('Are you sure you want to logout?');
    if (confirmed) {
      this.logout();
    }
  }

  logout(): void {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (err) {
      // ignore storage errors
    }
    this.router.navigate(['/login']);
  }
}